import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_20: FaireProductEntity = {
  token: "viverano-20",
  type: "product",
  name: "Floral Print & Lace Baby Girl Romper (Organic)",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/57a5b9f703e5c7046b15cc1f92abda74dbd1db19c346be0f0dd629dadba6326d.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 22.5,
  msrpDollars: 38,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
